import { render, staticRenderFns } from "./AutomaticDelivery.vue?vue&type=template&id=537dac54&scoped=true&"
import script from "./AutomaticDelivery.vue?vue&type=script&lang=js&"
export * from "./AutomaticDelivery.vue?vue&type=script&lang=js&"
import style0 from "./AutomaticDelivery.vue?vue&type=style&index=0&id=537dac54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537dac54",
  null
  
)

export default component.exports